/**
 * 页内子导航（客户 / 费用顶部的几个面；设置页左栏）。
 * 权限不够的面不渲染。选中态沿用 `.shell-link.is-active`（主色 10% 底）。
 */
import { NavLink, Outlet } from 'react-router';
import type { NavItem } from './navItems';

export function SubNav({
  items,
  vertical = false,
  label,
}: {
  items: readonly NavItem[];
  vertical?: boolean;
  label: string;
}) {
  if (items.length <= 1 && !vertical) return null;
  return (
    <nav className={`subnav${vertical ? ' is-vertical' : ''}`} aria-label={label}>
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.exact ?? false}
            className={({ isActive }) => `shell-link${isActive ? ' is-active' : ''}`}
          >
            {vertical ? <Icon /> : null}
            <span>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}

/** 嵌套路由的布局：顶部一排子面 + 子路由内容（设置 · 电话线路 / 短信 / 加微）。 */
export function SubNavOutlet({ items, label }: { items: readonly NavItem[]; label: string }) {
  return (
    <>
      <SubNav items={items} label={label} />
      <Outlet />
    </>
  );
}
